<template>
  <div class="risk-factors-list">
    <v-row>
      <v-col v-for="factor in factorsList" :key='factor.key' cols="12" md="4" lg="4" sm="4">
        <div class="risk-factor-item"
             :class="factor.checked ? 'selected' : ''"
             @click="factor.checked = !factor.checked"
        >
          <div v-if="factor.description !== false">
            <div v-if="isMobile">
              <v-btn class="mx-2 factor-desc" fab dark x-small color="#e2e9fb" @click.stop="factor.infoDialog = true">
                <v-icon color="#456ddd">mdi-help</v-icon>
              </v-btn>
              <v-dialog fullscreen hide-overlay transition="dialog-bottom-transition" v-model="factor.infoDialog" v-if="factor.description !== false">
                <v-card>
                  <v-card-title class="display-1">{{ factor.name }}</v-card-title>
                  <v-card-text class="headline black--text" >
                    <v-row>
                      <v-col><p>{{ factor.description }}</p></v-col>
                    </v-row>
                    <v-row>
                      <v-col><v-btn @click="factor.infoDialog = false" color="primary">Закрыть</v-btn></v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </div>
            <div v-else>
              <v-btn class="mx-2 factor-desc" fab dark x-small color="#e2e9fb">
                <v-tooltip top max-width="800px" content-class="tooltip-wrapper">
                  <template v-slot:activator="{ on }">
                    <v-icon color="#456ddd" v-on="on" @click.stop="'return false'" >mdi-help</v-icon>
                  </template>
                  <div v-html="factor.description"></div>
                </v-tooltip>
              </v-btn>
            </div>
          </div>
          <span :class='factor.checked ? factor.icons.hover : factor.icons.default' class="hp-icon" ></span>
          <p class="subtitle-1">{{ factor.name }}</p>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col align="start">
        <v-btn color="primary" @click="goNext">Применить</v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'RiskFactors',
  data: function () {
    return {
      factorsList: [
        {
          key: 1,
          name: 'Курение',
          icons: {
            default: 'hp-icon-smoking_02',
            hover: 'hp-icon-smoking_02'
          },
          // checked: false,
          checked: this.$store.getters.riskFactors.filter(function(elem) {return elem.key == 1}).length > 0 ? true : false,
          description: false,
          infoDialog: false
        },
        {
          key: 2,
          name: 'Липидный обмен',
          icons: {
            default: 'hp-icon-lipid_01',
            hover: 'hp-icon-lipid_02'
          },
          // checked: false,
          checked: this.$store.getters.riskFactors.filter(function(elem) {return elem.key == 2}).length > 0 ? true : false,
          description: "Общий холестерин > 4,9 ммоль/л (190 мг/дл) и/или ЛПНП > 3,0 ммоль/л (115 мг/дл). <br> Холестерин ЛПВП < 1,0 ммоль/л (40 мг/дл) у мужчин и < 1,2 ммоль/л (46 мг/дл) у женщин.<br>Триглицериды > 1,7 ммоль/л (150 мг/дл)",
          infoDialog: false
        },
        {
          key: 3,
          name: 'Ожирение',
          icons: {
            default: 'hp-icon-obesity_01',
            hover: 'hp-icon-obesity_02'
          },
          // checked: false,
          checked: this.$store.getters.riskFactors.filter(function(elem) {return elem.key == 3}).length > 0 ? true : false,
          description: 'Индекс массы тела превышает 30 кг/кв.м',
          infoDialog: false
        }
      ],
    }
  },
  methods: {
    goNext: function () {
      let checkedFactors = this.factorsList.filter(function (elem) { return elem.checked == true; })
      this.$emit('riskFactorsAreSet', checkedFactors)
    }
  },
  computed: {
    isMobile: function () {
      return screen.width < 600
    },
  },
  created() {
      // this.isMobile = screen.width < 600
  }
}
</script>

<style scoped lang="scss">
  .risk-factors-list {
    padding: 5px;
  }
  .risk-factor-item {
    cursor: pointer;
    transition: background 0.7s ease;
    text-align: center;
    padding: 7px 0px;
    border-radius: 5px;
    box-sizing: border-box;
    position: relative;
    background: rgba(0,0,0,0.03);
    .factor-desc {
      position: absolute;
      top: 0px;
      right: -8px;
      width: 25px;
      height: 25px;
      &:hover:before {
        color: red;
      }
    }
    .hp-icon {
      font-size: 3rem;
      color: #858585;
    }
    &.selected {
      box-shadow: 0px 0px 4px 1px rgba(69, 109, 221, 0.4);
      .hp-icon {
        color: #456ddd
      }
    }
    &:hover {
      background: rgba(0,0,0,0.07);
      /*border: 1px dashed #456ddd;*/
      .hp-icon {
        color: #456ddd;
      }
    }
  }
</style>
